import React, { useState } from 'react';
import { Button, FormControl, Grid, InputLabel, Select, Stack, MenuItem, Typography } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
  
const FileSelection = ({ showFileExplorer, 
    filesSelected, 
    isCalculateDifference, 
    configFiles,
    configSelected,
    setConfigSelected,
}) => {

    const [focused, setFocused] = useState(false);

    const handleChange = (configName,index) => {
        setConfigSelected(prevState => {
            const state = {...prevState}
            state[index] = configName;
            return state;
        });
    }

    const handleFocus = (e) => {
        setFocused(true);
    }

    const handleBlur = (e) => {
        setFocused(false);
    }

    const formatNameWithoutPath = (name) => { 
        return name?.includes("/") ? 
        name.substring(name.lastIndexOf("/") + 1) 
        : name 
    }

    const formatConfigName = (name) => {
        if(name === ''){
            return '(none)';
        }
        return formatNameWithoutPath(name);
    }

    const loadFileExplorer = () => {
        showFileExplorer(true);
    }

    return (
        <>
            <Grid item xs={12} style={{ paddingBottom: '10px'}}>
                <Button endIcon={<KeyboardArrowRightIcon />} onClick={() => loadFileExplorer()}>
                    Select files
                </Button>
            </Grid>
            {filesSelected.map((mapFile,index)=> (
                (!isCalculateDifference || (isCalculateDifference && index <=1)) &&
                <Grid container xs={12}>
                    <Grid
                    container
                    item
                    xs={3}
                    style={{ paddingBottom: '10px' }}
                    alignItems="center"
                    >
                    <Typography>
                        {formatNameWithoutPath(mapFile)}
                    </Typography>
                    </Grid>
                    {(!isCalculateDifference || (isCalculateDifference && index === 0)) &&
                    <Grid item xs={9} style={{ paddingBottom: '10px'}} >
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                {focused ? 'Config': 'Select config from server'}
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={configSelected[index] ? configSelected[index] : ''}
                                label="Config"
                                onChange={(e) => handleChange(e.target.value,index)}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                hidden={isCalculateDifference && index > 0}
                            >
                                {configFiles?.map((config) => (
                                    <MenuItem value={config} key={config}>
                                        {formatConfigName(config)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                }
                </Grid>
            ))}
            </>
    )
}

export default FileSelection